import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import { setupPinia } from '@/store'

import { setupI18n } from '@/locales/setupI18n'

// normalize.css
import 'normalize.css/normalize.css'

// global css
import '@/style/main.scss'

// tailwindcss
import '@/style/tailwind.css'

// vant
import 'vant/es/dialog/style'
import 'vant/es/toast/style'

import { ENV } from '@/constant'

import { showDialog } from 'vant'

console.log('[当前环境ENV] ', ENV)

const app = createApp(App)
setupI18n(app)
setupPinia(app)

window.addEventListener(
  'error',
  (e) => {
    console.error('全局统一错误拦截：', e)
    // TODO: 上报逻辑
    return true
  },
  true,
)

// 处理未捕获的异常，主要是promise内部异常，统一抛给 onerror
window.addEventListener('unhandledrejection', (e) => {
  console.error('promise内部reject抛出的异常: ', e)
  throw e.reason
})

app.config.errorHandler = function (e) {
  console.log('e: ', e)
  showDialog({ message: `js代碼錯誤：${String(e)}（點擊確認后可以選擇重試或退出）` })
}

app.use(router).mount('#app')
